"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrolledIntoView = void 0;
class ScrolledIntoView {
    // used to check if entire div is in View, returns false if not.
    check(element) {
        const docViewTop = window.scrollY;
        const docViewBottom = docViewTop + document.documentElement.clientHeight;
        let elemRect;
        if (document.getElementById(element)) {
            elemRect = document.getElementById(element).getBoundingClientRect();
            const elemTop = elemRect.top + docViewTop;
            const elemBottom = elemRect.bottom + docViewTop;
            return ((elemBottom <= docViewBottom) && elemTop >= docViewTop);
        }
        else {
            // element doesn't exist...
            return true;
        }
    }
    // provide ID to scroll into view
    scrollToElement(element) {
        let elemRect;
        if (document.getElementById(element)) {
            elemRect = document.getElementById(element).getBoundingClientRect();
            // window.scrollY - how far user has scrolled
            // elemRect.top - how far down from the scroll position is the div
            // .getBoundingClientRect().height - header height
            // 75 - additional padding for mobile
            const headerElement = document.getElementById('mma_header');
            if (headerElement && headerElement.getBoundingClientRect()) {
                window.scrollTo(0, window.scrollY + elemRect.top - headerElement.getBoundingClientRect().height - 75);
            }
            else {
                window.scrollTo(0, window.scrollY + elemRect.top - 75);
            }
        }
    }
}
exports.ScrolledIntoView = ScrolledIntoView;
//# sourceMappingURL=scrolledIntoView.js.map